jQuery(document).ready(function ($) {
    $(".copy-button").click(function () {
        let couponCode = $(this).data("coupon");
        let $notice = $(this).siblings(".copy-notice");

        let tempInput = $("<input>");
        $("body").append(tempInput);
        tempInput.val(couponCode).select();
        document.execCommand("copy");
        tempInput.remove();

        $notice.removeClass("hidden").css("display", "inline-block").fadeIn();

        setTimeout(function () {
            $notice.fadeOut();
        }, 2000);
    });
});
